import { render, staticRenderFns } from "./NlpButton.vue?vue&type=template&id=da2580c8&scoped=true"
import script from "./NlpButton.vue?vue&type=script&lang=js"
export * from "./NlpButton.vue?vue&type=script&lang=js"
import style0 from "./NlpButton.vue?vue&type=style&index=0&id=da2580c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2580c8",
  null
  
)

export default component.exports